"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _oxygenConstants = require("@8x8/oxygen-constants");

var _polished = require("polished");

var select = {
  fontFamily: _oxygenConstants.font.family,
  fontSize: _oxygenConstants.font.sizeSm,
  lineHeight: _oxygenConstants.font.lineHeightSm,
  marginTop: _oxygenConstants.spacing.xxs,
  borderColor: _oxygenConstants.color.cloudyBlue300,
  borderColorFocus: _oxygenConstants.color.dodgerBlue,
  borderColorError: _oxygenConstants.color.coral,
  borderColorDisabled: _oxygenConstants.color.cloudyBlue300,
  valueContainerPadding: _oxygenConstants.spacing.xs,
  backgroundColor: _oxygenConstants.color.white,
  backgroundColorDisabled: _oxygenConstants.color.cloudyBlue100,
  indicatorsContainerPaddingHorizontal: _oxygenConstants.spacing.xs,
  placeholderTextColor: _oxygenConstants.color.cloudyBlue,
  placeholderIconColor: _oxygenConstants.color.cloudyBlue,
  selectedOptionTextColor: _oxygenConstants.color.steel700,
  dropdownIndicatorColor: _oxygenConstants.color.steel700,
  dropdownIndicatorColorDisabled: _oxygenConstants.color.cloudyBlue100,
  iconPaddingRight: _oxygenConstants.spacing.xs,
  iconHeight: _oxygenConstants.size.medium,
  clearIconColor: _oxygenConstants.color.cloudyBlue,
  clearIconFocusedColor: _oxygenConstants.color.steel700,
  clearIconHoverColor: _oxygenConstants.color.steel700,
  clearIconFocusedHoverColor: _oxygenConstants.color.pickledBluewood,
  inputBoxSizeDefault: _oxygenConstants.size.formItemSizeLarge,
  inputBoxSizeSmall: _oxygenConstants.size.formItemSizeSmall,
  inputColor: _oxygenConstants.color.pickledBluewood,
  labelFontWeight: _oxygenConstants.font.weightAttention,
  optionTextFontSize: _oxygenConstants.font.sizeSm,
  optionTextFontWeightSelected: _oxygenConstants.font.weightAttention,
  optionTextColor: _oxygenConstants.color.pickledBluewood,
  optionIconColor: _oxygenConstants.color.pickledBluewood,
  optionTextSelectedColor: _oxygenConstants.color.dodgerBlue,
  optionPaddingVertical: _oxygenConstants.spacing.xxs,
  optionPaddingHorizontal: _oxygenConstants.spacing.xs,
  optionActiveBackgroundColor: _oxygenConstants.color.cloudyBlue300,
  optionHoveredBackgroundColor: _oxygenConstants.color.cloudyBlue100,
  noOptionTextColor: _oxygenConstants.color.cloudyBlue,
  noOptionTextFontSize: _oxygenConstants.font.sizeSm,
  menuBackgroundColor: _oxygenConstants.color.white,
  menuBoxShadowColor: "".concat((0, _polished.rgba)(_oxygenConstants.color.pickledBluewood800, 0.1)),
  menuBoxShadowSize: _oxygenConstants.size.shadowDefault,
  menuBorderSize: _oxygenConstants.size.borderSizeDefault,
  menuBorderColor: _oxygenConstants.color.cloudyBlue300,
  menuBorderStyle: 'solid',
  menuZindex: _oxygenConstants.zIndex.z1000,
  avatarPaddingRight: _oxygenConstants.spacing.xs,
  checkboxPaddingRight: _oxygenConstants.spacing.xs,
  headingTextFontSize: _oxygenConstants.font.sizeSm,
  headingTextFontWeight: _oxygenConstants.font.weightAttention,
  headingTextColor: _oxygenConstants.color.pickledBluewood,
  headingBorderStyle: 'solid',
  headingBorderColor: _oxygenConstants.color.cloudyBlue300,
  headingBorderSize: _oxygenConstants.size.borderSizeDefault,
  headingPadding: _oxygenConstants.spacing.xs,
  headingMargin: 0,
  controlFocusBoxShadow: 'none',
  multiValueChipBackgroundColor: _oxygenConstants.color.cloudyBlue100,
  multiValueChipTextColor: _oxygenConstants.color.steel700,
  multiValueChipHoveredBackgroundColor: _oxygenConstants.color.dodgerBlue100,
  multiValueChipHoveredTextColor: _oxygenConstants.color.pickledBluewood,
  multiValueChipFontSize: _oxygenConstants.font.sizeXs,
  multiValueChipMarginRight: _oxygenConstants.spacing.xs,
  multiValueChipPaddingVerticalDefault: '6px',
  multiValueChipPaddingVerticalSmall: _oxygenConstants.spacing.xxxs,
  multiValueChipPaddingLeft: _oxygenConstants.spacing.xs,
  multiValueChipPaddingRight: _oxygenConstants.spacing.xl,
  multiValueChipBorderRadius: _oxygenConstants.size.borderRadiusSmall,
  multiValueChipCloseIconColor: _oxygenConstants.color.steel700,
  multiValueChipCloseIconHoveredColor: _oxygenConstants.color.dodgerBlue300,
  multiValueChipCloseIconChipHoveredColor: _oxygenConstants.color.dodgerBlue,
  shortMultiDisplayPadding: _oxygenConstants.spacing.xxs,
  borderRadius: 0,
  menuGutter: 1,
  baseUnit: 0
};
var _default = select;
exports["default"] = _default;